import React, { Suspense } from 'react';
import { Box, Spinner } from '@chakra-ui/react';
import CampaignList from './CampaignList';

const Campaigns: React.FC = () => {
  return (
    <Box width="full" mb={8}>
      <Suspense fallback={<Spinner size="sm" />}>
        <CampaignList />
      </Suspense>
    </Box>
  );
};

export default Campaigns;